import { getStoredToken, getTokenFromUrl } from "./buyerToken";

const STORED_SHOPIFY_CUSTOMER_ID_KEY = "buy-again-shopify-customer-id";

function getWindowCustomerId(): number | null {
  if (typeof window === "undefined") return null;
  const id = (window as unknown as { meta?: { page?: { customerId?: number } } })
    ?.meta?.page?.customerId;
  return id != null && Number.isFinite(id) ? id : null;
}

function getStoredShopifyCustomerId(): number | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORED_SHOPIFY_CUSTOMER_ID_KEY);
    if (raw == null || raw === "") return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

function persistShopifyCustomerIdFromWindow(id: number): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORED_SHOPIFY_CUSTOMER_ID_KEY, String(id));
  } catch {
    /* ignore quota / private mode */
  }
}

export function hasCustomerId(): boolean {
  return (
    getWindowCustomerId() != null ||
    getStoredShopifyCustomerId() != null ||
    getTokenFromUrl() != null ||
    getStoredToken() != null
  );
}

export type CustomerIdentifier =
  | { type: "id"; shopify_customer_id: number }
  | { type: "token"; buy_again_token: string };

export function getCustomerIdentifier(): CustomerIdentifier | null {
  const winId = getWindowCustomerId();
  if (winId != null) {
    persistShopifyCustomerIdFromWindow(winId);
    return { type: "id", shopify_customer_id: winId };
  }
  const urlToken = getTokenFromUrl();
  if (urlToken) return { type: "token", buy_again_token: urlToken };
  const token = getStoredToken();
  if (token) return { type: "token", buy_again_token: token };
  const storedId = getStoredShopifyCustomerId();
  if (storedId != null) return { type: "id", shopify_customer_id: storedId };
  return null;
}

export function buildQueryParams(identifier: CustomerIdentifier): string {
  if (identifier.type === "id") {
    return `shopify_customer_id=${encodeURIComponent(identifier.shopify_customer_id)}`;
  }
  return `buy_again_token=${encodeURIComponent(identifier.buy_again_token)}`;
}
